import { render, staticRenderFns } from "./RoundProfileImage.vue?vue&type=template&id=f9b260c0&scoped=true&"
import script from "./RoundProfileImage.vue?vue&type=script&lang=js&"
export * from "./RoundProfileImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b260c0",
  null
  
)

export default component.exports